module.exports = __webpack_public_path__ + "img/s560-maybach-black.fd67f7de.png";